import * as React from "react"
export const Svg_071 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={59}
    fill="none"
  >
    <g clipPath="url(#a)">
      <path
        fill="url(#b)"
        d="m39.305 15.195-17.849 2.47v3.884l17.849-2.47v-3.884Z"
      />
      <path
        fill="url(#c)"
        d="M15.952 42.245a2.047 2.047 0 1 0 0-4.094 2.047 2.047 0 0 0 0 4.094Z"
      />
      <path
        fill="url(#d)"
        d="M37.258 38.625a2.047 2.047 0 1 0 0-4.095 2.047 2.047 0 0 0 0 4.095Z"
      />
      <path
        fill="url(#e)"
        d="M50.361 8.645C44.791 3.075 37.384.006 29.494.006 21.616.006 14.21 3.074 8.64 8.645 3.068 14.215 0 21.622 0 29.5c0 7.879 3.068 15.285 8.639 20.856 5.57 5.57 12.977 8.639 20.867 8.639 7.878 0 15.285-3.068 20.855-8.639C55.932 44.786 59 37.379 59 29.5c0-7.878-3.068-15.284-8.639-20.855Zm-7.6 27.933a5.51 5.51 0 0 1-5.503 5.504 5.51 5.51 0 0 1-5.505-5.504 5.51 5.51 0 0 1 5.505-5.504c.723 0 1.414.14 2.047.394V22.57l-17.849 2.47v15.159a5.51 5.51 0 0 1-5.504 5.504 5.51 5.51 0 0 1-5.504-5.504 5.51 5.51 0 0 1 5.504-5.504c.723 0 1.414.14 2.047.394V14.653l24.763-3.426v25.35Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={25.584}
        x2={27}
        y1={16.148}
        y2={22.587}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={14.852}
        x2={16.797}
        y1={38.765}
        y2={41.913}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={36.157}
        x2={38.102}
        y1={35.145}
        y2={38.292}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={13.644}
        x2={41.661}
        y1={8.854}
        y2={54.207}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h59v59H0z" />
      </clipPath>
    </defs>
  </svg>
)